import React from "react";
import { Link } from "react-router-dom";
// @ts-ignore
import "./HowItWorksSection.css";

const steps = [
  {
    n: "01",
    icon: "fas fa-route",
    title: "Tell us about your trip",
    text: "Share your pickup and drop-off, date, time, passengers, and luggage. One-way, round-trip, hourly, and airport transfers all start with one short form.",
  },
  {
    n: "02",
    icon: "fas fa-file-invoice-dollar",
    title: "Review your quote",
    text: "We reply with vehicle availability and a clear rate for your trip. Nothing is finalized until you review and approve the details.",
  },
  {
    n: "03",
    icon: "fas fa-car-side",
    title: "Ride with your chauffeur",
    text: "Once confirmed, your chauffeur arrives on schedule. For airport pickups we agree the flight details and meeting point before you travel.",
  },
];

export default function HowItWorksSection(): JSX.Element {
  return (
    <section className="how-section py-5" id="how-it-works">
      <div className="container">
        <div className="text-center mb-5 gs-anim">
          <span className="section-badge">How It Works</span>
          <h2 className="section-title">Booked in Three Simple Steps</h2>
          <p className="section-sub">
            No apps to install and no surprises. Tell us the trip, approve the
            quote, and we handle the drive.
          </p>
        </div>

        <div className="row g-4 how-grid">
          {steps.map((step, i) => (
            <div className="col-12 col-md-4 gs-anim" key={step.n}>
              <div className="how-card h-100">
                <span className="how-num" aria-hidden="true">
                  {step.n}
                </span>
                <div className="how-icon">
                  <i className={step.icon} aria-hidden="true"></i>
                </div>
                <h3 className="how-title">{step.title}</h3>
                <p className="how-text">{step.text}</p>
                {i < steps.length - 1 && (
                  <span className="how-line" aria-hidden="true">
                    <i className="fas fa-chevron-right"></i>
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="how-cta text-center gs-anim">
          <Link
            to="/get-a-quote"
            className="btn gs-btn-gold"
            title="Start your quote request"
          >
            <i className="far fa-calendar-check me-2"></i>Start a Quote
          </Link>
          <a
            href="tel:9294526031"
            className="how-call"
            title="Call GS Limo Elite at (929) 452-6031"
          >
            or call <strong>(929) 452-6031</strong>
          </a>
        </div>
      </div>
    </section>
  );
}
